/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignScrapeRequest, CampaignScrapeResponse } from '../types/CampaignScrape'

/**
 * POST /campaigns/scrape
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::scrape
 */
export async function campaignScrape(
	data: CampaignScrapeRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignScrapeResponse>> {
	return axiosInstance.post('/campaigns/scrape', data, config)
}
